/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LandlordPartnerRowDto } from './LandlordPartnerRowDto';
import {
    LandlordPartnerRowDtoFromJSON,
    LandlordPartnerRowDtoFromJSONTyped,
    LandlordPartnerRowDtoToJSON,
    LandlordPartnerRowDtoToJSONTyped,
} from './LandlordPartnerRowDto';

/**
 * 
 * @export
 * @interface ListLandlordsResponseDto
 */
export interface ListLandlordsResponseDto {
    /**
     * 
     * @type {Array<LandlordPartnerRowDto>}
     * @memberof ListLandlordsResponseDto
     */
    items: Array<LandlordPartnerRowDto>;
    /**
     * 
     * @type {number}
     * @memberof ListLandlordsResponseDto
     */
    activeSlaCount: number;
    /**
     * 
     * @type {number}
     * @memberof ListLandlordsResponseDto
     */
    avgUptimeTargetPct?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ListLandlordsResponseDto
     */
    avgPenaltyPerDay: number;
    /**
     * 
     * @type {number}
     * @memberof ListLandlordsResponseDto
     */
    totalFees: number;
}

/**
 * Check if a given object implements the ListLandlordsResponseDto interface.
 */
export function instanceOfListLandlordsResponseDto(value: object): value is ListLandlordsResponseDto {
    if (!('items' in value) || value['items'] === undefined) return false;
    if (!('activeSlaCount' in value) || value['activeSlaCount'] === undefined) return false;
    if (!('avgPenaltyPerDay' in value) || value['avgPenaltyPerDay'] === undefined) return false;
    if (!('totalFees' in value) || value['totalFees'] === undefined) return false;
    return true;
}

export function ListLandlordsResponseDtoFromJSON(json: any): ListLandlordsResponseDto {
    return ListLandlordsResponseDtoFromJSONTyped(json, false);
}

export function ListLandlordsResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListLandlordsResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(LandlordPartnerRowDtoFromJSON)),
        'activeSlaCount': json['activeSlaCount'],
        'avgUptimeTargetPct': json['avgUptimeTargetPct'] == null ? undefined : json['avgUptimeTargetPct'],
        'avgPenaltyPerDay': json['avgPenaltyPerDay'],
        'totalFees': json['totalFees'],
    };
}

export function ListLandlordsResponseDtoToJSON(json: any): ListLandlordsResponseDto {
    return ListLandlordsResponseDtoToJSONTyped(json, false);
}

export function ListLandlordsResponseDtoToJSONTyped(value?: ListLandlordsResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': ((value['items'] as Array<any>).map(LandlordPartnerRowDtoToJSON)),
        'activeSlaCount': value['activeSlaCount'],
        'avgUptimeTargetPct': value['avgUptimeTargetPct'],
        'avgPenaltyPerDay': value['avgPenaltyPerDay'],
        'totalFees': value['totalFees'],
    };
}

